export function setRenderedAppState(isAppRendered = true) {
  return dispatch => {
    dispatch({
      type: 'SET_RENDERED_APP_STATE',
      payload: {
        isAppRendered,
      },
    })
  }
}

export function setAppActionsDisabledState(areAppActionsDisabled) {
  return dispatch => {
    dispatch({
      type: 'SET_APP_ACTIONS_DISABLED_STATE',
      payload: {
        areAppActionsDisabled,
      },
    })
  }
}
